module.exports = __webpack_public_path__ + "img/glasdach.1d394c97.webp";